import { compose, is, path } from 'ramda'

export default {
  decisionMade: compose(is(Boolean), path(['decision'])),
  decision: path(['decision']),
}
